jQuery(document).ready(function ($) {
    $('.faq__question').off('click').on('click', function () {
        $(this).parent().toggleClass('faq__question-container--active');
        $(this).parent().find('.faq__answer').slideToggle();
    });

    // Select all links with hashes
    $('a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .click(function (event) {
                // On-page links
                if (
                        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                        &&
                        location.hostname == this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top - 178
                        }, 1000, function () {
                            // Callback after animation
                            // Must change focus!
                            var $target = $(target);
                            $target.focus();
                            if ($target.is(":focus")) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }

                        });
                    }
                }
            });

    // JS Breakpoints
    var isBreakPoint = function (bp) {
        var bps = [0, 767, 1024, 3500],
                w = $(window).width(),
                min, max
        for (var i = 0, l = bps.length; i < l; i++) {
            if (bps[i] === bp) {
                min = bps[i - 1] || 0
                max = bps[i]
                break
            }
        }
        return w > min && w <= max
    }

    // Fix FAQ nav
    if ($('body.page-template-page-faq').length) {
        var stickyHeader = $('body').offset().top + 468;
        if (isBreakPoint(1024)) {
            stickyHeader = $('body').offset().top + 280;
        }
        if (isBreakPoint(767)) {
            stickyHeader = $('body').offset().top + 300;
        }
        $(window).on('scroll', function () {
            // console.log($(window).scrollTop());
            if ($(window).scrollTop() >= stickyHeader) {
                $('body').addClass('fix-top');
            } else {
                $('body').removeClass('fix-top');
            }
        });
    }

    var a_sections = $('.faq__questions-inner'),
            a_nav = $('.faq__categories');

    $(window).on('scroll', function () {
        var cur_pos = $(this).scrollTop();

        a_sections.each(function () {
            // console.log(cur_pos);
            var top = $(this).offset().top - 210,
                    bottom = top + $(this).outerHeight(),
                    id = $(this).attr('id');

            if (cur_pos > 480) {
                if (cur_pos >= top && cur_pos <= bottom) {
                    a_nav.find('a').parent().removeClass('faq__category--active');

                    // strip '_scrollto' from id
                    id = id.replace('_scrollto', '');
                    a_nav.find('a[href="#' + id + '"]').parent().addClass('faq__category--active');
                }
            } else {
                a_nav.find('a').parent().removeClass('faq__category--active');
                $('.faq__category:first-child').addClass('faq__category--active');
            }
        });
    });

});
